<ng-container *transloco="let t; read: 'CARBONSCORE_MODAL_COMPONENT'">
  <ion-toolbar>
    <div class="toolbar-header moderate-background with-handle">
      <ion-button (click)="dismissModal()" fill="none" color="secondary">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
      <h1>{{ t('TITLE') }}</h1>
      <div class="right"></div>
    </div>
  </ion-toolbar>
  <ion-content class="ion-padding">
    <ng-container [ngSwitch]="language$ | async" class="ion-padding">
      <app-carbonscore-modal-en *ngSwitchCase="'en'"></app-carbonscore-modal-en>
      <app-carbonscore-modal-fr *ngSwitchCase="'fr'"></app-carbonscore-modal-fr>
    </ng-container>
  </ion-content>
</ng-container>
